<template>
  <div id="recruitment">
    <div class="top">
      <div
        @click="showActionSheet('药物名称')"
        :class="drugList.length > 0 ? 'check' : ''"
      >
        药物名称
        <i
          class="iconfont"
          :class="drugList.length > 0 ? 'icon-shangsanjiao' : 'icon-xiasanjiao'"
          style="font-size: 12px"
        ></i>
      </div>
      <div
        @click="showActionSheet('适应症')"
        :class="tissueChList.length > 0 ? 'check' : ''"
      >
        适应症
        <i
          class="iconfont"
          :class="
            tissueChList.length > 0 ? 'icon-shangsanjiao' : 'icon-xiasanjiao'
          "
          style="font-size: 12px"
        ></i>
      </div>

      <div
        @click="showActionSheet('分期')"
        :class="phasesEnList.length > 0 ? 'check' : ''"
      >
        分期
        <i
          class="iconfont"
          :class="
            phasesEnList.length > 0 ? 'icon-shangsanjiao' : 'icon-xiasanjiao'
          "
          style="font-size: 12px"
        ></i>
      </div>
      <div
        @click="showActionSheet('地点')"
        :class="locationsList.length > 0 ? 'check' : ''"
      >
        地点
        <i
          class="iconfont"
          :class="
            locationsList.length > 0 ? 'icon-shangsanjiao' : 'icon-xiasanjiao'
          "
          style="font-size: 12px"
        ></i>
      </div>
    </div>

    <div class="bottomCuntent">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefreshList"
        loosing-text="释放刷新"
        pulling-text="下拉刷新"
        success-text="刷新成功"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text=""
          :immediate-check="false"
          @load="onLoadList"
        >
          <RecruitmentDetail :dataList="dataList"></RecruitmentDetail>
          <Empty v-if="dataList == ''" />
        </van-list>
      </van-pull-refresh>
    </div>

    <!-- 药物弹窗 -->
    <van-popup
      v-model="isDrug"
      closeable
      position="bottom"
      :style="{ height: '100%' }"
      @click-close-icon="closeDrug"
    >
      <Drug ref="drug" @child="drugChild($event)" />
    </van-popup>
    <!-- 适应症弹框 -->
    <van-popup
      v-model="isCancer"
      closeable
      position="bottom"
      :style="{ height: '100%' }"
      @click-close-icon="closeCancer"
    >
      <Cancer ref="cancer" @child="cancerChild($event)" />
    </van-popup>
    <!-- 分期弹框 -->
    <van-popup
      v-model="isStages"
      closeable
      position="bottom"
      :style="{ height: '100%' }"
      @click-close-icon="closeStages"
    >
      <Stages ref="stages" @child="stagesChild($event)" />
    </van-popup>
    <!-- 地点弹框 -->
    <van-popup
      v-model="isPlace"
      closeable
      position="bottom"
      :style="{ height: '100%' }"
      @click-close-icon="closePlace"
    >
      <Place ref="place" @child="placeChild($event)" />
    </van-popup>
  </div>
</template>

<script>
import { findTissueChAndDrugList } from "@/api/wxapi.js";
import RecruitmentDetail from "./components/RecruitmentDetail.vue";
import Drug from "./components/drug.vue";
import Cancer from "./components/cancer.vue";
import Stages from "./components/stages.vue";
import Place from "./components/place.vue";

export default {
  components: { RecruitmentDetail, Drug, Cancer, Stages, Place },
  data() {
    return {
      isPlace: false,
      isStages: false,
      isCancer: false,
      isDrug: false,

      isLoading: false,
      loading: false,
      finished: false,
      total: 0,
      page: 1,
      dataList: [],
      drugList: [],
      locationsList: [],
      phasesEnList: [],
      tissueChList: [],
      site: 0,
    };
  },
  methods: {
    closeCancer() {
      if (this.tissueChList.length == 0 || this.drugList.length < 0) {
        this.$refs.cancer.clear();
      }
    },
    closeStages() {
      if (this.phasesEnList.length == 0 || this.drugList.length < 0) {
        this.$refs.stages.clear();
      }
    },
    closePlace() {
      if (this.locationsList.length == 0 || this.drugList.length < 0) {
        this.$refs.place.clear();
      }
    },
    closeDrug(e) {
      console.log(e);
      console.log(this.drugList);
      if (this.drugList.length == 0 || this.drugList.length < 0) {
        this.$refs.drug.clear();
      }
    },
    showActionSheet(name) {
      switch (name) {
        case "药物名称":
          this.isDrug = true;
          break;
        case "适应症":
          this.isCancer = true;
          break;
        case "分期":
          this.isStages = true;
          break;
        case "地点":
          this.isPlace = true;
          break;
        default:
          break;
      }
    },
    // 列表刷新
    onRefreshList() {
      this.page = 1;
      this.dataList = [];
      this.isLoading = false;
      this.loading = true;
      this.getList();
    },
    // 列表加载
    onLoadList() {
      this.page++;
      this.getList();
    },
    // 地点组件调用
    placeChild(palceArr) {
      // this.loading =false
      this.finished = false;

      this.page = 1;
      this.dataList = [];
      this.isPlace = false;
      console.log(palceArr, "自组件参数");
      this.locationsList = palceArr;
      this.getList();
    },
    // 分期组件调用
    stagesChild(stagesArr) {
      // this.loading =false
      this.finished = false;

      this.page = 1;
      this.dataList = [];
      this.isStages = false;
      console.log(stagesArr, "自组件参数");
      this.phasesEnList = stagesArr;
      this.getList();
    },
    // 适应症组件调用
    cancerChild(cancerArr) {
      // this.loading =false
      this.finished = false;

      this.page = 1;
      this.dataList = [];
      this.isCancer = false;
      console.log(cancerArr, "自组件参数");
      this.tissueChList = cancerArr;
      this.getList();
    },
    // 药物组件调用
    drugChild(drugArr) {
      // this.loading =false
      this.finished = false;

      this.page = 1;
      this.dataList = [];
      this.isDrug = false;
      console.log(drugArr, "自组件参数drug");
      this.drugList = drugArr;
      this.getList();
    },
    getList() {
      findTissueChAndDrugList({
        drugList: this.drugList, //药物数组
        locationsList: this.locationsList, // 地点
        phasesEnList: this.phasesEnList, //分期
        tissueChList: this.tissueChList, //适应症
        pageNo: this.page,
        site: this.site,
        pageSize: 10,
      }).then((res) => {
        if (this.isLoading) {
          console.log("111111122222");
          this.dataList = [];
          this.isLoading = false;
        }
        console.log(res);
        this.total = res.data.total;
        let rows = res.data.records;
        this.loading = false;
        if (rows == null || rows.length === 0) {
          this.finished = true;
          return;
        }
        this.dataList = [...this.dataList, ...rows];
        if (this.dataList.length >= this.total) {
          this.finished = true;
        }
        // this.dataList = res.data.records;
      });
    },
  },
  mounted() {
    this.getList();
  },
  computed: {},
};
</script>
<style lang="less" scoped>
/deep/.van-tabs__line {
  left: -14px;
}
/deep/.van-tab {
  justify-content: start;
}
/deep/.van-search {
  padding: 0;
}
/deep/.van-tabs__nav--line {
  padding-right: 200px;
  padding-bottom: 10px;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.checked {
  color: #4b84ff !important;
}
.checkbox {
  color: #2f354d !important;
}
/deep/.checkIcon {
  margin-right: 8px;
}
/deep/.van-tabs__line {
  background: #4b84ff;
  width: 24px;
}
#recruitment {
  width: 100%;
  padding-top: 40px;
  .bottomCuntent {
    padding: 0 16px;
  }
}
.top {
  display: flex;
  width: 100%;
  align-items: center;
  height: 40px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9;
  background: #ffffff;
  .check {
    color: #4b84ff;
    i {
      color: #4b84ff;
    }
  }
  div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    i {
      margin: 2px 0 0 3px;
      transform: scale(0.9);
    }
  }
}
</style>



